import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { convertFilterToArray } from 'src/utils/convertFilter';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { fetchPaymentOrderByIdRequest, fetchPaymentOrderHistoryRequest, fetchPaymentOrdersRequest } from './requestHandlers';
import { IPaymentHistoryItemData, IPaymentOrderListData } from './types';

const defaultParams = {
  page: '0',
  size: '10',
  sort: 'orderCreatedAt,desc',
};

export const loadPaymentOrderStart = createAction('payment_orders/load/start');
export const loadPaymentOrderListSuccess = createAction<IPaymentOrderListData>('payment_orders/load/success');
export const loadPaymentOrderItemStart = createAction('payment_orders/item/load/start');
export const loadPaymentOrderItemSuccess = createAction<IPaymentHistoryItemData>('payment_orders/item/load/success');
export const resetPaymentOrderItem = createAction('payment_orders/item/reset');

export const loadPaymentOrdersRequest = (
  history: RouteComponentProps['history'],
  params: IQueryParams = {},
  isInitialLoading?: boolean,
  type?: string,
) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadPaymentOrderStart());
    }
    const initialParams = qs.parse(history.location.search);
    const mergedParams = type === 'reset' ? defaultParams : removeEmpty({ ...defaultParams, ...initialParams, ...params });

    mergedParams.merchantIds = convertFilterToArray(mergedParams.merchantIds);
    mergedParams.merchantAccountIds = convertFilterToArray(mergedParams.merchantAccountIds);
    mergedParams.systemGroupFormIds = convertFilterToArray(mergedParams.systemGroupFormIds);
    mergedParams.statuses = convertFilterToArray(mergedParams.statuses);
    mergedParams.providerNames = convertFilterToArray(mergedParams.providerNames);

    const res = await fetchPaymentOrdersRequest(mergedParams);
    if (res) {
      dispatch(loadPaymentOrderListSuccess(res));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};

export const loadPaymentOrderItemRequest = ({ orderId, orderIdentity }: { orderId: string; orderIdentity: string }) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    dispatch(loadPaymentOrderItemStart());

    const general = await fetchPaymentOrderByIdRequest(orderId);
    const history = await fetchPaymentOrderHistoryRequest({ orderIdentity });

    if (!general || !history) {
      return;
    }

    dispatch(
      loadPaymentOrderItemSuccess({
        general,
        history: history.refillHistoryLog,
        resendCallbackStatus: history.resendCallbackStatus,
      }),
    );
  };
};
